<script setup>

import BusySpinner from "@/components/common/other/BusySpinner.vue";
import NoDataFoundBanner from "@/components/shipments/NoDataFoundBanner.vue";

const emit = defineEmits(['downloadDocument']);

const props = defineProps({

  modelValue: {}
})

function downloadDocument(doc) {

  emit("downloadDocument", doc);
}
</script>

<template>
  <div class="cmp-document-download-layout_wrapper" v-if="modelValue.length > 0" >
    <div class="cmp-document-download-layout_headers">
      <div>Quote Number</div>
      <div>Invoice Number</div>
      <div>Title</div>
      <div>Comments</div>
      <div> Download</div>
      <div></div>
    </div>
    <div class="cmp-document-download-layout_list-wrapper">
      <div v-for="doc in modelValue" :key="doc.id" class="cmp-document-download-layout_data-boxes-wrapper">
        <div id="boxes" style="width: 100px;" :title="doc.quoteNumber">{{doc.quoteNumber}}</div>
        <div id="boxes" style="width: 105px;" :title="doc.invoiceNumber">{{doc.invoiceNumber}}</div>
        <div id="boxes" style="width: 240px;" :title="doc.name">{{doc.name}}</div>
        <div id="boxes" style="width: 205px;" :title="doc.description">{{doc.description}}</div>
        <div v-if="!doc.downloaded && !doc.isDownloading" @click="downloadDocument(doc)" class="cmp-document-download-layout_download-icon">
          &#128464
        </div>
        <div v-else-if="doc.downloaded" class="cmp-document-download-layout_downloaded-icon">
          &#128504
        </div>
        <div v-if="doc.isDownloading" class="cmp-document-download-layout_busy-downloader">
          <BusySpinner :hide="!doc.isDownloading" message=""></BusySpinner>
        </div>
      </div>
    </div>
  </div>
  <div v-else><NoDataFoundBanner>📂 No Current Documents</NoDataFoundBanner></div>
</template>

<style scoped lang="scss">

.cmp-document-download-layout {

  &_wrapper {
    font-size: 13px;
    //height: 124px;
    width: 860px;
  }

  &_list-wrapper {
    margin-top: 10px;
    height: 100px;
    overflow-y: scroll;
  }

  &_headers {
    display: grid;
    grid-template-columns: 130px 135px 270px 220px 100px;
    padding: 4px;
    font-weight: bold;
  }

  &_data-boxes-wrapper {
    display: flex;
    gap: 20px;
  }

  &_data-boxes-wrapper #boxes {
    display: flex;
    align-items: center;
    height: 16px;
    border: 1px solid #e7e7e7;
    padding: 5px;
    margin-top: 5px;
    border-radius: 2px;
    overflow: hidden;
    white-space: nowrap;
    background: #fff;
    border-radius: 8px;
  }

  &_download-icon {
    display: flex;
    align-items: center;
    color: #F68E1E;
    font-size: 18px;
    border: none!important;
    cursor: pointer;
    background: #fdfdfd!important;
    //margin-left: 5px;
  }

  &_download-icon:hover {
    color: #0b3080;
  }

  &_downloaded-icon {
    display: flex;
    align-items: center;
    color: #288a49;
    font-size: 20px;
    margin-left: 3px;
  }

  &_busy-downloader {
    border: none!important;
    background: #fdfdfd!important;
    display: flex;
    justify-content: center;
    align-items: center;
  }

}




</style>